/* src/app/shared/components/login/login.component.less */
@font-face {
  font-family: "icomoon";
  src: url(/assets/fonts/icomoon.eot?69pa3q);
  src:
    url(/assets/fonts/icomoon.eot?69pa3q#iefix) format("embedded-opentype"),
    url(/assets/fonts/icomoon.ttf?69pa3q) format("truetype"),
    url(/assets/fonts/icomoon.woff?69pa3q) format("woff"),
    url(/assets/fonts/icomoon.svg?69pa3q#icomoon) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-],
[class*=" icon-"] {
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-arrow_left_white:before {
  content: "\e900";
}
.icon-arrow_right_blue:before {
  content: "\e901";
}
.icon-arrow-left:before {
  content: "\e902";
}
.icon-arrow-right:before {
  content: "\e903";
}
.icon-camera:before {
  content: "\e904";
}
.icon-checkmark:before {
  content: "\e905";
}
.icon-exit:before {
  content: "\e906";
}
.icon-grid_view:before {
  content: "\e907";
}
.icon-printer:before {
  content: "\e908";
}
.icon-refresh:before {
  content: "\e909";
}
.icon-warning:before {
  content: "\e90a";
}
button {
  background-color: transparent;
  height: 4.5rem;
  padding: 1rem 2rem 1rem 2rem;
  display: flex;
  align-items: center;
  letter-spacing: 0;
}
.btn-primary,
.content .wrapper > .actions button.login {
  font-weight: 600;
  border-radius: 0.5rem;
  box-shadow: 0 0.3rem 0.7rem 0 rgba(0, 0, 0, 0.3);
  color: #005eb8;
  background-color: #ffffff;
  border: solid 0.1rem;
  border-color: #ffffff;
  box-sizing: border-box;
  flex: 0 0 auto;
}
.btn-primary:focus,
.btn-primary.focus {
  color: #005eb8;
  background-color: #e6e6e6;
  border-color: #bfbfbf;
}
.btn-primary:hover {
  color: #005eb8;
  background-color: #e6e6e6;
  border-color: #e0e0e0;
}
.btn-primary:active,
.btn-primary.active,
.open > .dropdown-toggle.btn-primary {
  color: #005eb8;
  background-color: #e6e6e6;
  border-color: #e0e0e0;
}
.btn-primary:active:hover,
.btn-primary.active:hover,
.open > .dropdown-toggle.btn-primary:hover,
.btn-primary:active:focus,
.btn-primary.active:focus,
.open > .dropdown-toggle.btn-primary:focus,
.btn-primary:active.focus,
.btn-primary.active.focus,
.open > .dropdown-toggle.btn-primary.focus {
  color: #005eb8;
  background-color: #d4d4d4;
  border-color: #bfbfbf;
}
.btn-primary:active,
.btn-primary.active,
.open > .dropdown-toggle.btn-primary {
  background-image: none;
}
.btn-primary.disabled:hover,
.btn-primary[disabled]:hover,
fieldset[disabled] .btn-primary:hover,
.btn-primary.disabled:focus,
.btn-primary[disabled]:focus,
fieldset[disabled] .btn-primary:focus,
.btn-primary.disabled.focus,
.btn-primary[disabled].focus,
fieldset[disabled] .btn-primary.focus {
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-primary .badge {
  color: #ffffff;
  background-color: #005eb8;
}
.btn-primary-revert,
.footer button.exit {
  font-weight: 600;
  border-radius: 0.5rem;
  box-shadow: 0 0.3rem 0.5rem 0 rgba(0, 0, 0, 0.3);
  color: #ffffff;
  background-color: #005eb8;
  border: solid 0.1rem;
  border-color: #ffffff;
  box-sizing: border-box;
  flex: 0 0 auto;
}
.btn-primary-revert:focus,
.btn-primary-revert.focus {
  color: #ffffff;
  background-color: #004485;
  border-color: #bfbfbf;
}
.btn-primary-revert:hover {
  color: #ffffff;
  background-color: #004485;
  border-color: #e0e0e0;
}
.btn-primary-revert:active,
.btn-primary-revert.active,
.open > .dropdown-toggle.btn-primary-revert {
  color: #ffffff;
  background-color: #004485;
  border-color: #e0e0e0;
}
.btn-primary-revert:active:hover,
.btn-primary-revert.active:hover,
.open > .dropdown-toggle.btn-primary-revert:hover,
.btn-primary-revert:active:focus,
.btn-primary-revert.active:focus,
.open > .dropdown-toggle.btn-primary-revert:focus,
.btn-primary-revert:active.focus,
.btn-primary-revert.active.focus,
.open > .dropdown-toggle.btn-primary-revert.focus {
  color: #ffffff;
  background-color: #003261;
  border-color: #bfbfbf;
}
.btn-primary-revert:active,
.btn-primary-revert.active,
.open > .dropdown-toggle.btn-primary-revert {
  background-image: none;
}
.btn-primary-revert.disabled:hover,
.btn-primary-revert[disabled]:hover,
fieldset[disabled] .btn-primary-revert:hover,
.btn-primary-revert.disabled:focus,
.btn-primary-revert[disabled]:focus,
fieldset[disabled] .btn-primary-revert:focus,
.btn-primary-revert.disabled.focus,
.btn-primary-revert[disabled].focus,
fieldset[disabled] .btn-primary-revert.focus {
  background-color: #005eb8;
  border-color: #ffffff;
}
.btn-primary-revert .badge {
  color: #005eb8;
  background-color: #ffffff;
}
.btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.switch {
  position: relative;
  display: inline-block;
  width: 5rem;
  height: 2.4rem;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 1.6rem;
  width: 1.6rem;
  left: 0.4rem;
  bottom: 0.4rem;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: #2196f3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(2.6rem);
  -ms-transform: translateX(2.6rem);
  transform: translateX(2.6rem);
}
input:focus + .slider {
  box-shadow: 0 0 0.1rem #2196f3;
}
.slider.round {
  border-radius: 3.4rem;
}
.slider.round:before {
  border-radius: 50%;
}
::-webkit-scrollbar {
  width: 1rem;
}
::-webkit-scrollbar-thumb {
  border-radius: 1rem;
  background-color: #19345e;
  border-color: #0d498b;
}
::-webkit-scrollbar-track {
  border-radius: 1rem;
  background-color: #0d498b;
}
daui-dialog .modal-content::-webkit-scrollbar-thumb {
  border-radius: 1rem;
  background-color: #acb4b9;
  border-color: #ffffff;
}
daui-dialog .modal-content::-webkit-scrollbar-track {
  border-radius: 1rem;
  background-color: #ffffff;
}
form .form-row,
.form .form-row {
  display: flex;
  flex-direction: row;
  gap: 1.2rem;
  width: 100%;
}
form .form-row .input-group,
.form .form-row .input-group {
  min-height: 9.85rem;
  width: 26.7rem;
}
form .form-row .input-group label,
.form .form-row .input-group label {
  align-items: center;
  display: flex;
}
form .form-row .input-group label daui-signposts,
.form .form-row .input-group label daui-signposts {
  margin-left: 0.6rem;
}
form .form-row + .form-row,
.form .form-row + .form-row {
  margin-top: 1.8rem;
}
form .input-group,
.form .input-group {
  color: #ffffff;
  position: relative;
  width: 42rem;
}
form .input-group > label,
.form .input-group > label {
  display: flex;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: 2.3rem;
  width: 100%;
}
form .input-group > label > .required,
.form .input-group > label > .required {
  color: #ffffff;
  margin-right: 0.5rem;
}
form .input-group > .feedback,
.form .input-group > .feedback {
  font-size: 1.2rem;
  height: 1.8rem;
  line-height: 1.8rem;
  margin-top: 0.25rem;
  width: 100%;
}
form .input-group .icon,
.form .input-group .icon {
  background-size: contain;
  display: block;
  height: 2.4rem;
  position: absolute;
  right: 1.3rem;
  top: 4.1rem;
  width: 2.4rem;
}
form .input-group > .icon + input,
.form .input-group > .icon + input {
  padding-right: 3.6rem;
}
form .input-group > .form-control,
.form .input-group > .form-control {
  width: 100%;
  height: 5rem;
  padding: 0.375rem 0.75rem;
  border: 0.2rem solid #ffffff;
  background-color: #ffffff;
  color: #25292b;
  font-size: 1.8rem;
}
form .input-group input[type=date]::-webkit-calendar-picker-indicator,
.form .input-group input[type=date]::-webkit-calendar-picker-indicator {
  background-image: none;
}
form .input-group input[type=date]:before,
.form .input-group input[type=date]:before {
  content: attr(placeholder);
  color: #acb4b9;
  width: 100%;
}
form .input-group input[type=date]:focus:before,
.form .input-group input[type=date]:focus:before,
form .input-group input[type=date].not-empty:before,
.form .input-group input[type=date].not-empty:before {
  content: none;
}
form .input-group input.ng-touched.ng-invalid,
.form .input-group input.ng-touched.ng-invalid,
form .input-group textarea.ng-touched.ng-invalid,
.form .input-group textarea.ng-touched.ng-invalid,
form .input-group select.ng-touched.ng-invalid,
.form .input-group select.ng-touched.ng-invalid {
  border-color: #e52e39;
  color: #f5b6ba;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2222px%22%20height%3D%2222px%22%20viewBox%3D%220%200%2022%2022%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20fill%3D%22%23e52e39%22%20d%3D%22M12%2C1.33333333%20C17.8914133%2C1.33333333%2022.6666667%2C6.11000889%2022.6666667%2C12.0005689%20C22.6666667%2C17.8914133%2017.8914133%2C22.6666667%2012%2C22.6666667%20C6.10858667%2C22.6666667%201.33333333%2C17.8914133%201.33333333%2C12.0005689%20C1.33333333%2C6.11000889%206.10858667%2C1.33333333%2012%2C1.33333333%20Z%20M12%2C3.33333333%20C7.21361709%2C3.33333333%203.33333333%2C7.21411742%203.33333333%2C12.0005689%20C3.33333333%2C16.7869153%207.21322764%2C20.6666667%2012%2C20.6666667%20C16.7867724%2C20.6666667%2020.6666667%2C16.7869153%2020.6666667%2C12.0005689%20C20.6666667%2C7.21411742%2016.7863829%2C3.33333333%2012%2C3.33333333%20Z%20M13%2C16%20L13%2C18%20L11%2C18%20L11%2C16%20L13%2C16%20Z%20M13%2C6%20L13%2C14.6666667%20L11%2C14.6666667%20L11%2C6%20L13%2C6%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Warning%22%20transform%3D%22translate(-1.000000%2C%20-1.000000)%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2224%22%20height%3D%2224%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Warning%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E");
}
form .input-group input.ng-touched.ng-invalid,
.form .input-group input.ng-touched.ng-invalid,
form .input-group textarea.ng-touched.ng-invalid,
.form .input-group textarea.ng-touched.ng-invalid {
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  padding-right: calc(1.5em + 0.75rem);
  background-repeat: no-repeat;
}
form .input-group input.ng-touched.ng-invalid::-webkit-input-placeholder,
.form .input-group input.ng-touched.ng-invalid::-webkit-input-placeholder,
form .input-group textarea.ng-touched.ng-invalid::-webkit-input-placeholder,
.form .input-group textarea.ng-touched.ng-invalid::-webkit-input-placeholder {
  color: #f5b6ba;
}
form .input-group input.ng-touched.ng-invalid::-moz-placeholder,
.form .input-group input.ng-touched.ng-invalid::-moz-placeholder,
form .input-group textarea.ng-touched.ng-invalid::-moz-placeholder,
.form .input-group textarea.ng-touched.ng-invalid::-moz-placeholder {
  color: #f5b6ba;
}
form .input-group input.ng-touched.ng-invalid:-ms-input-placeholder,
.form .input-group input.ng-touched.ng-invalid:-ms-input-placeholder,
form .input-group textarea.ng-touched.ng-invalid:-ms-input-placeholder,
.form .input-group textarea.ng-touched.ng-invalid:-ms-input-placeholder {
  color: #f5b6ba;
}
form .input-group select.ng-touched.ng-invalid,
.form .input-group select.ng-touched.ng-invalid {
  background-position: right 1.75rem center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  padding-right: calc(0.75em + 2.3125rem);
  background-repeat: no-repeat;
}
form .input-group input:focus,
.form .input-group input:focus,
form .input-group textarea:focus,
.form .input-group textarea:focus,
form .input-group select:focus,
.form .input-group select:focus {
  border-color: #158cff;
  -webkit-box-shadow: 0 0 0.6rem #7bbeff;
  -moz-box-shadow: 0 0 0.6rem #7bbeff;
  box-shadow: 0 0 0.6rem #7bbeff;
}
form .input-group input.ng-touched.ng-invalid:focus,
.form .input-group input.ng-touched.ng-invalid:focus,
form .input-group textarea.ng-touched.ng-invalid:focus,
.form .input-group textarea.ng-touched.ng-invalid:focus,
form .input-group select.ng-touched.ng-invalid:focus,
.form .input-group select.ng-touched.ng-invalid:focus {
  border-color: #c71923;
  -webkit-box-shadow: 0 0 0.6rem #eb5b64;
  -moz-box-shadow: 0 0 0.6rem #eb5b64;
  box-shadow: 0 0 0.6rem #eb5b64;
}
form select.placeholder,
.form select.placeholder {
  color: #acb4b9;
}
input[type=checkbox] {
  appearance: none;
  border: none;
  height: 2.2rem;
  margin-right: 1rem;
  width: 2.2rem;
}
input[type=checkbox]:before {
  background-color: #ffffff;
  content: "";
  height: 2.2rem;
  width: 2.2rem;
}
input[type=checkbox]:checked {
  appearance: none;
  border: 0;
}
input[type=checkbox]:checked:before {
  display: inline-block;
  content: "";
  height: 2.2rem;
  width: 2.2rem;
  background-image: url('data:image/svg+xml,<svg version="1.1" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg"><title>BE391523-4D56-4019-9092-3EE5D799E0F8</title><g fill="none" fill-rule="evenodd"><g transform="translate(-214 -409)"><g transform="translate(214 337)"><g transform="translate(0 2)"><g transform="translate(0 70)"><rect x=".5" y=".5" width="21" height="21" fill="%23fff" stroke="%23fff"/><g transform="translate(2 2)" fill="%23005EB8"><path d="m18 0v18h-18v-18h18zm-4.475 3.596-5.9037 5.904-2.9833-2.983-2.121 2.121 5.1043 5.1046 8.0247-8.0256-2.121-2.121z"/></g></g></g></g></g></g></svg>');
  background-size: 2.2rem 2.2rem;
  background-repeat: no-repeat;
}
input[type=checkbox]:hover {
  cursor: pointer;
}
input[type=checkbox] + label {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.7rem;
}
.text-primary,
.content .wrapper > .actions button.login .icon,
.content .wrapper > .actions button > .picto {
  color: #005eb8;
}
.text-white,
.footer button.exit .icon-arrow-left {
  color: #ffffff;
}
.badge {
  font-size: 1.269rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: #ffffff;
  vertical-align: baseline;
  white-space: nowrap;
  text-shadow: 0 -0.1rem 0 rgba(0, 0, 0, 0.25);
  background-color: #6e7a80;
  padding: 0.5rem 1.5rem 0.5rem;
  border-radius: 1.5rem;
}
.badge-purple {
  background-color: #ab77b3;
}
.badge-green {
  background-color: #85c85a;
}
.badge-yellow {
  background-color: #c4b44f;
}
ng-autocomplete .auto-complete-item {
  font-size: 1.8rem;
}
.shadow-top {
  -moz-box-shadow: inset 0rem 0.5rem 1rem -0.5rem rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0rem 5px 1rem -0.5rem rgba(0, 0, 0, 0.2);
  box-shadow: inset 0rem 0.5rem 1rem -0.5rem rgba(0, 0, 0, 0.2);
}
.shadow-bot {
  -moz-box-shadow: inset 0rem -0.5rem 1rem -0.5rem rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0rem -0.5rem 1rem -0.5rem rgba(0, 0, 0, 0.2);
  box-shadow: inset 0rem -0.5rem 1rem -0.5rem rgba(0, 0, 0, 0.2);
}
.shadow-top-bot {
  box-shadow: inset 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.2);
}
@media only screen and (min-width: 768px) {
  input[type=text] {
    max-width: 42rem;
  }
  input[type=number] {
    max-width: 42rem;
  }
  input[type=password] {
    max-width: 42rem;
  }
  input[type=email] {
    max-width: 42rem;
  }
  input[type=tel] {
    max-width: 42rem;
  }
}
.footer button.exit .icon-arrow-left {
  margin-right: 1.5rem;
}
.content .wrapper > .actions button.login .icon {
  margin-left: 1.5rem;
}
.content .wrapper > .actions button.login .icon,
.footer button.exit .icon-arrow-left {
  vertical-align: middle;
}
:host {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  min-height: 100%;
  flex: 1 1 auto;
  background-color: #005eb8;
}
.content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 7rem 4rem 2rem 4rem;
  overflow: auto;
}
.content > h1.title,
.content > h2.title,
.content > h3.title {
  text-align: center;
  margin: 0;
}
.content > h1.title.left,
.content > h2.title.left,
.content > h3.title.left {
  text-align: left;
}
.content > h2.title,
.content > h3.title {
  color: #f5f9fc;
  font-weight: 400;
  line-height: 2.7rem;
}
.content > h1.title {
  font-size: 3.2rem;
  font-weight: 600;
  color: #ffffff;
  line-height: 4.2rem;
}
.content > h2.title {
  font-size: 1.8rem;
}
.content > h3.title {
  font-size: 1.2rem;
}
.content > h1.title + h2.title {
  margin-top: 1.5rem;
}
.content > h2.title + h3.title {
  margin-top: 2rem;
}
.content > h2.title + h2.title {
  margin-top: 2rem;
}
.content > .wrapper,
.content > .image {
  margin-bottom: 3.5rem;
  margin-top: 3.5rem;
}
.content > .step {
  color: #f5f9fc;
  font-size: 1.8rem;
  line-height: 2.7rem;
  margin: 0;
}
.content > .step + h1.title {
  margin-top: 1.2rem;
}
.content > .actions {
  display: flex;
  margin-top: 3.5rem;
}
.content > .actions button {
  margin: 0rem 2rem;
}
.content form > .input-group {
  height: 10rem;
}
.content form :not(:first-child).input-group {
  margin-top: 1.5rem;
}
.content.loader {
  justify-content: center;
}
.content .wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-top: 15rem;
}
.content .wrapper > .loader {
  margin-top: 5rem;
}
.content .wrapper > .image {
  display: flex;
  flex: 1;
}
.content .wrapper > .image i {
  font-size: 10rem;
  line-height: 10rem;
  color: #ffffff;
}
.content .wrapper > .actions {
  flex-direction: column;
  margin-top: 5rem;
}
.content .wrapper > .actions :not(:first-child).action {
  margin-top: 2rem;
}
.content .wrapper > .actions button {
  height: 6rem;
  width: 18rem;
  padding: 1rem 1.5rem;
  margin: 0;
}
.content .wrapper > .actions button > .picto {
  font-size: 3rem;
  width: 4rem;
  margin-right: 2.5rem;
}
.content .wrapper > .actions button .sub-label {
  display: flex;
  flex: 1;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 2.3rem;
  text-align: left;
}
.content .wrapper > .actions button .label {
  display: flex;
  flex: 1;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.3rem;
  text-align: left;
}
.footer button .title {
  color: #ffffff;
  margin-top: 4rem;
  font-size: 4.8rem;
  font-weight: 700;
}
/*# sourceMappingURL=login.component.css.map */
